var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 47C36.4787 47 47 36.4787 47 23.5C47 10.5213 36.4787 0 23.5 0C10.5213 0 0 10.5213 0 23.5C0 36.4787 10.5213 47 23.5 47Z",
    fill: "#EC5C29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.85 13.9355C25.85 11.9812 26.6154 10.5961 28.2 9.72628L35.5748 6.58811L35.6025 6.58V7.8255C35.6025 9.60422 35.5987 11.383 35.5947 13.1617V13.1629C35.5853 17.6113 35.5757 22.0596 35.626 26.508C35.6495 28.764 34.639 30.1975 32.6415 31.0905C32.2063 31.2844 31.7699 31.4775 31.3318 31.6705L29.845 32.3031L25.85 34.0031V14.1H25.8512L25.85 13.9355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.244 24.252C21.244 26.1085 21.244 27.683 21.244 29.234C21.244 30.644 21.244 32.054 21.244 33.464C21.244 34.827 20.7035 36.0255 19.552 36.6365C17.014 37.976 14.382 39.1275 11.515 40.467C11.515 39.386 11.515 38.6105 11.515 37.8585C11.515 35.7905 11.515 33.699 11.515 31.631C11.515 30.174 11.9615 28.7875 13.2305 28.106C15.745 26.7195 18.4005 25.5915 21.244 24.252Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg55);
export default __webpack_public_path__ + "static/media/55.313e59e6ce07b99d2121bb8e241a39ab.svg";
export { ForwardRef as ReactComponent };